<div class="p-3">


  <header class="fs-24 fw-600 ms-2 pt-2 hex-65-grey">Detail Search</header>
  <form class="form form-inline mb-4 ms-2" role="search" (submit)="search()">
    <div class="form-group col-md-4 col-sm-12 p-0 d-flex">
      <input [(ngModel)]="term" name="searchTerm" class="form-control rounded-0  " type="text" id="search_input"
        placeholder="Type and click on search" autocomplete="off" />
        <button type="submit" class="btn btn-primary btn-sm p-1 mx-2" id="search_btn">Search</button>
        <button class="btn btn-primary  " (click)="location.back()">Back</button>
      </div>

    </form>

    @if (emptyData) {
      <div class="card card-default ">
        <div class="card-header">Search - "{{term?term:''}}"</div>
        <div class="card-body">
          <p class="text-center">No Result Found!</p>
        </div>
      </div>
    }

    <div class="row m-0 mx-5 p-0 px-5">
      @if ((show && show.doctor) && !emptyData) {
        <div
          >
          <div class="card card-default p-2">
            <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Businesses</h3>
            <div class="p-2 row">
              @for (doctor of results; track doctor) {
                <div class="col-md-12 mb-3"
                  [routerLink]="'/app/business/details/'+doctor.doctor_id">
                  <div class="col-12 py-2 border rounded clickable-item px-2 ">
                    <h3 class="my-1 text-green fs-24">
                      {{doctor.doctor_name ? doctor.doctor_name : 'N/A'}}
                    </h3>
                    <div class="row">
                      <div class="col-6 text-label">
                        <span class="text-muted">Email:</span>
                        <span [innerHTML]="doctor.doctor_email | highlight:searched_string"></span>
                      </div>
                      <div class="col-6 text-label"><span class="text-muted">Phone:</span>
                    {{doctor.doctor_mobile}}</div>
                    <div class="col-6 text-label">
                      <span class="text-muted">Business Name:</span>
                      <span [innerHTML]="doctor.practice_name | highlight:searched_string"></span>
                    </div>
                    <div class="col-6 text-label">
                      <span class="text-muted">Business Email:</span>
                      <span [innerHTML]="doctor.practice_email | highlight:searched_string"></span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if ((show && show.contract) && !emptyData) {
      <div
        >
        <div class="card card-default p-2">
          <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Contracts</h3>
          <div class="p-2 row">
            @for (contract of results; track contract) {
              <div class="col-md-12 mb-3"
                [routerLink]="'/app/contracts/details/'+contract.contract_id" id="contract_details">
                <div class="col-12 py-2 border rounded clickable-item px-2 ">
                  <h3 class="my-1 text-green fs-24">
                    <span [innerHTML]="contract.contract_code | highlight:searched_string"
                    class="h3 text-bold fs-24 me-2"></span>
                    @if (contract.pf_status<3) {
                      <span class="badge bg-primary float-right">Active</span>
                    }
                    @if (contract.pf_status==3) {
                      <span class="badge bg-warning float-right">Overdue</span>
                    }
                    @if (contract.pf_status==4) {
                      <span class="badge bg-success float-right">Completed</span>
                    }
                    @if (contract.pf_status==5) {
                      <span class="badge bg-danger float-right">Canceled</span>
                    }
                  </h3>
                  <div class="row">
                    <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
                    {{contract.doctor_title}} <span
                  [innerHTML]="contract.doctor_name | highlight:searched_string:'capital'"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
                <span [innerHTML]="contract.doctor_email | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Customer Name:</span>
              <span [innerHTML]="contract.patient_name | highlight:searched_string:'capital'"></span>
            </div>
            <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
            <span [innerHTML]="contract.patient_email | highlight:searched_string"></span>
          </div>
        </div>
      </div>
    </div>
  }
</div>
</div>
</div>
}

@if ((show && show.partner) && !emptyData) {
  <div
    >
    <div class="card card-default p-2">
      <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Partners</h3>
      <div class="p-2 row">
        @for (partner of results; track partner) {
          <div class="col-md-12 mb-3"
            (click)="viewPartner(partner.partner_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">{{partner.title}}
                <span class="h3 text-bold fs-24"
                [innerHTML]="partner.partner_name | highlight:searched_string:'capital'"></span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Email:</span>
                <span [innerHTML]="partner.partner_email | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Phone:</span>
            {{partner.partner_mobile}}</div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
</div>
}

@if ((show && show.patient) && !emptyData) {
  <div
    >
    <div class="card card-default p-2">
      <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Customers</h3>
      <div class="p-2 row">
        @for (patient of results; track patient) {
          <div class="col-md-12 mb-3"
            [routerLink]="'/app/customers/profile/'+patient.patient_id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">{{patient.patient_title}}
                <span class="h3 text-bold fs-24"
                [innerHTML]="patient.patient_name | highlight:searched_string:'capital'"></span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Email:</span>
                <span [innerHTML]="patient.patient_email | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Phone:</span>
            {{patient.patient_mobile}}</div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
</div>
}

@if ((show && show.payments) && !emptyData) {
  <div
    >
    <div class="card card-default p-2">
      <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Payments Processed</h3>
      <div class="p-2 row">
        @for (payment of results; track payment) {
          <div class="col-md-12 mb-3"
            [routerLink]="'/app/payment-processing/'+payment.id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">
                <span class="h3 text-bold fs-24"
                [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
                @if (payment.status==1) {
                  <span class="badge bg-warning float-right">Pending</span>
                }
                @if (payment.status==2) {
                  <span class="badge bg-success float-right">Success</span>
                }
                @if (payment.status==3) {
                  <span class="badge bg-danger float-right">Failed</span>
                }
                @if (payment.status==4) {
                  <span class="badge bg-info float-right">Refunded</span>
                }
                @if (payment.status==5) {
                  <span class="badge bg-danger float-right">Declined</span>
                }
              </h3>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email:</span>
                  <span [innerHTML]="payment.patient_email | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label">
                  <span class="text-muted">Phone:</span>
                  {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}
                </div>
                <div class="col-12 text-label">
                  <span class="text-muted">Payment ID:</span>
                  @if (payment.payment_process_code) {
                    <span
                    [innerHTML]="payment.payment_process_code | highlight:searched_string"></span>
                  }
                  @if (!payment.payment_process_code) {
                    <span>N/A</span>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

@if ((show && show.ar) && !emptyData) {
  <div >
    @if (results; as proposal_ar) {
      <ng-container
      *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal_ar, heading: 'Debt Recovery', link: '/app/debt-recovery/details/'}}"></ng-container>
    }
  </div>
}
@if ((show && show.proposal) && !emptyData) {
  <div
    >
    @if (results; as proposal) {
      <ng-container
      *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal, heading: 'Proposal Request', link: '/app/proposal/details/'}}"></ng-container>
    }
  </div>
}

@if ((show && show.pa_leads) && !emptyData) {
  <div
    >
    <div class="card card-default p-2">
      <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Pre-approval Leads</h3>
      <div class="p-2 row">
        @for (lead of results; track lead) {
          <div class="col-md-12 mb-3"
            [routerLink]="'/app/patients/customers-leads/details/'+lead.application_id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">
                <span [innerHTML]="lead.application_id | highlight:searched_string" class="h3 text-bold fs-24"></span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
                <span
                [innerHTML]="(lead.doctor_first_name + lead.doctor_last_name) | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
              <span [innerHTML]="lead.doctor_email | highlight:searched_string"></span>
            </div>
            <div class="col-6 text-label"><span class="text-muted">Customer Name:</span>
            <span [innerHTML]="lead.full_cust_name | highlight:searched_string"></span>
          </div>
          <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
          <span [innerHTML]="lead.customer_email | highlight:searched_string"></span>
        </div>
      </div>
    </div>
  </div>
}
</div>
</div>
</div>
}

@if ((show && show.leads) && !emptyData) {
  <div
    >
    <div class="card card-default p-2">
      <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Leads</h3>
      <div class="p-2 row">
        @for (user of results; track user) {
          <div class="col-md-12 mb-3" (click)="navigateToDetails(user)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">
                <span class="h3 text-bold fs-24"
                [innerHTML]="(user.first_name + ' ' + user.last_name) | highlight:searched_string:'capital'"></span>
                <span class="text-muted fs-14 fw-600 float-right">ID: {{ user.lead_id }}</span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Email:</span>
                <span [innerHTML]="user.practice_email | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Phone:</span>
              {{user.practice_mobile ? user.practice_mobile : 'N/A'}}
            </div>
            <div class="col-6 text-label"><span class="text-muted">Business Name:</span>
            <span [innerHTML]="(user.practice_name || 'N/A') | highlight:searched_string"></span>
          </div>
        </div>
      </div>
    </div>
  }
</div>
</div>
</div>
}

@if ((show && show.training) && !emptyData) {
  <div
    >
    <div class="card card-default p-2">
      <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Trainings</h3>
      <div class="p-2 row">
        @for (trianing of results; track trianing) {
          <div class="col-md-12 mb-3"
            [routerLink]="'/app/training/details/'+trianing.training_event_time_slot_id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">
                <span [innerHTML]="trianing.training_doctor_partner_name | highlight:searched_string:'capital'"
                class="h3 text-bold fs-24 me-2"></span>
                <span class=" rounded fs-20 text-white float-right p-0 ps-2 pe-2 pb-1 text-center"
                [ngStyle]="{'background-color':trianing?.training_status_color_code || ''}">{{trianing?.training_status_name || ''}}</span>
              </h3>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email: </span>
                  <span [innerHTML]="trianing.training_doctor_partner_email | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                {{trianing.training_doctor_partner_phone? trianing.training_doctor_partner_phone : 'N/A'}}
              </div>
              <!-- <div class="col-6 text-label">
              <span class="text-muted">Type of Training: </span>
              <span [innerHTML]="trianing.type_name | highlight:searched_string"></span>
            </div> -->
            <div class="col-6 text-label">
              <span class="text-muted">Business Name: </span>
              <span [innerHTML]="(trianing.training_practice_name || 'N/A') | highlight:searched_string"></span>
            </div>
            <div class="col-6 text-label">
              <span class="text-muted">Business Email: </span>
              <span [innerHTML]="(trianing.practice_email || 'N/A') | highlight:searched_string"></span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
</div>
}
</div>

<ng-template #proposals_listing let-data="data">
  <div class="card card-default p-2">
    <h3>{{data.heading}}</h3>
    <div class="p-2 row">
      @for (payment of results; track payment) {
        <div class="col-md-12 mb-3" [routerLink]="data.link+payment.split_req_id">
          <div class="col-12 py-2 border rounded clickable-item px-2 ">
            <h3 class="my-1 text-green fs-24">
              <span class="h3 text-bold fs-24"
              [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
              @if (payment.status==1) {
                <span class="badge bg-warning float-right">Pending</span>
              }
              @if (payment.status==2) {
                <span class="badge bg-success float-right">Success</span>
              }
              @if (payment.status==3) {
                <span class="badge bg-danger float-right">Failed</span>
              }
              @if (payment.status==4) {
                <span class="badge bg-info float-right">Refunded</span>
              }
              @if (payment.status==5) {
                <span class="badge bg-danger float-right">Declined</span>
              }
            </h3>
            <div class="row">
              <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
              <span [innerHTML]="payment.doctor_name | highlight:searched_string"></span>
            </div>
            <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
            <span [innerHTML]="payment.doctor_email | highlight:searched_string"></span>
          </div>
          <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
        {{payment.patient_email ? (payment.patient_email): 'N/A'}}</div>
        <div class="col-6 text-label"><span class="text-muted">Customer Phone:</span>
      {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}</div>
      <!-- <div class="col-12 text-label">
      <span class="text-muted">Payment ID:</span>
      <span *ngIf="payment.payment_process_code"
      [innerHTML]="payment.payment_process_code | highlight:searched_string"></span>
      <span *ngIf="!payment.payment_process_code">N/A</span>
    </div> -->
  </div>
</div>
</div>
}
</div>
</div>
</ng-template>

@if (!emptyData) {
  <div class="d-flex m-0 pt-2 align-items-center inserted justify-content-between ">
    <div >
      <p class="fs-14 fw-500 m-0">
        Showing {{(1+(pageNumber - 1) * 10)}} to {{(results?.length + (pageNumber - 1) *
        10)}} of {{totalRows || 'all'}}
      </p>
    </div>
    <div >
      <pagination class="pagination-sm float-md-end" [totalItems]="totalRows" [maxSize]="5" [boundaryLinks]="true"
        [rotate]="false" (pageChanged)="pageChanged($event)" [(ngModel)]="pageNumber">
      </pagination>
    </div>
  </div>
}
</div>